import React, { useState, useRef } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import "./EditProfile.scss";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { editProfileService } from "../../../services/authService";
import { toastMessage, fileTypeMatch } from "../../../helper";
import CancelIcon from "@mui/icons-material/Cancel";
import { bulkUploadService } from "../../../services/emissionService";
import { successMessage } from "../../../constants/messageConstants";
import {
  EMAIL_REGEX,
  PHONE_NUMBER_INDIA_REGEX,
  PHONE_NUMBER_SINGAPORE_REGEX,
} from "../../../constants/regexConstants";
import { useTranslation } from "react-i18next";
import MapsInput from "../../common/MapsInput";
import { DIAL_CODE } from "../../../constants/enums";

const styles = (theme: any) => ({
  ".MuiOutlinedInput-notchedOutline": {
    border: "1px solid #D7DFE9",
    borderRadius: "8px",
    height: "3rem",
  },
  "&:hover": {
    ".MuiOutlinedInput-notchedOutline": {
      border: "2px solid #59CE90 !important",
    },
  },
});
const EditProfile = (props: any) => {
  const { t, i18n } = useTranslation();
  const { onClose } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const userInfostr = localStorage.getItem("user");
  const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
  if (userInfostr === null) {
    userInfo.mobile = "";
  }

  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [isAddAddressClicked, setIsAddAddressClicked] = React.useState(false);
  const [phone, setPhone] = useState(userInfo.dialCode + userInfo.mobile || "");

  const [isHomeSelected, setIsHomeSelected] = useState(false);
  const [isWorkSelected, setIsWorkSelected] = useState(false);
  const [allAddresses, setAllAddresses] = useState([
    { id: 1, isHomeSelected: true, isWorkSelected: false, address: "" },
  ]);
  const [errorData, setErrorData] = useState({
    emailError: "",
    nameError: "",
    phoneError: "",
  });
  const { emailError, nameError, phoneError } = errorData;
  const [formData, setFormData] = useState({
    displayName: userInfo.displayName || "",
    email: userInfo.email || "",
    profileImageUrl: userInfo.profileImageUrl,
    mobile: userInfo.mobile || "",
    phone: "",
    address: {
      addressLine1: userInfo.address?.addressLine1 || "",
      addressLine2: userInfo.address?.addressLine2 || "",
      city: userInfo.address?.city || "",
      cityCode: userInfo.address?.cityCode || "",
      state: userInfo.address?.state || "",
      stateCode: userInfo.address?.stateCode || "",
      country: userInfo.address?.country || "",
      countryCode: userInfo.address?.countryCode || "",
    },
    dialCode: userInfo?.dialCode || "",
  });
  let { displayName, email, address } = formData;

  const handleAddressClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    let total = allAddresses;
    total.push({
      id: total.length + 1,
      isHomeSelected: false,
      isWorkSelected: false,
      address: "",
    });
    setAllAddresses([...total]);
    setIsAddAddressClicked(true);
  };
  const onChangeAddress = (e: any) => {
    const newForm = { ...formData };
    newForm.address.addressLine1 = e.target.value.addressLine;
    newForm.address.stateCode = e.target.value.stateCode;
    newForm.address.countryCode = e.target.value.countryCode;
    newForm.address.city = e.target.value.city;
    newForm.address.cityCode = e.target.value.cityCode || "";
    newForm.address.state = e.target.value.state;
    newForm.address.country = e.target.value.country;
    setFormData(newForm);
  };
  const handleHomeAddressSelection = (
    event: React.MouseEvent<HTMLButtonElement>,
    address: any
  ) => {
    event.preventDefault();

    let tempAddresses = allAddresses;
    tempAddresses.map((elem) => {
      if (elem.id === address.id) {
        elem.isHomeSelected = true;
        elem.isWorkSelected = false;
      }
    });
    setAllAddresses([...tempAddresses]);
    setIsHomeSelected(true);
    setIsWorkSelected(false);
  };

  const handleWorkAddressSelection = (
    event: React.MouseEvent<HTMLButtonElement>,
    address: any
  ) => {
    event.preventDefault();
    let tempAddresses = allAddresses;
    tempAddresses.map((elem) => {
      if (elem.id === address.id) {
        elem.isHomeSelected = false;
        elem.isWorkSelected = true;
      }
    });
    setAllAddresses([...tempAddresses]);
    setIsHomeSelected(false);
    setIsWorkSelected(true);
  };

  const isValidForm = () => {
    return !nameError && !emailError && !phoneError;
  };
  const handleRemove = (address: any) => {
    let tempAddresses = allAddresses.filter((elem) => {
      if (elem.id !== address.id) {
        return elem;
      }
    });
    setAllAddresses([...tempAddresses]);
  };

  const company = JSON.parse(localStorage.getItem("company") || "{}");

  const validateFields = (name: string, value: string) => {
    let substrings = ["gmail", "yahoo"];
    if (name === "email") {
      console.log(value);
      setErrorData({ ...errorData, emailError: "" });
      //regex mail
      if (!EMAIL_REGEX.test(value)) {
        //setErrorData((prevState)=>{return {...prevState,emailError: "Invalid Email"}});
        setErrorData({ ...errorData, emailError: "Invalid Email" });
      } else if (
        substrings.some((v) => value.includes(v)) &&
        company.accountType === "CORPORATE"
      ) {
        setErrorData({
          ...errorData,
          emailError: "Use Only Company Emails For Registration",
        });
      }
    }
    if (name === "name") {
      setErrorData({ ...errorData, phoneError: "" });
      if (value.length < 3) {
        setErrorData({
          ...errorData,
          nameError: "Name should be greater than 3 letters",
        });
        //setErrorData((prevState)=>{return {...prevState,codeError: "Registration Id Should be 3 - 20 digit Alphanumeric"}});
      } else {
        setErrorData({ ...errorData, nameError: "" });
      }
    }
    if (name === "phone") {
      setErrorData({ ...errorData, phoneError: "" });
      let phone: any = value.split(" ");
      let dialcode = phone[0];
      if (
        dialcode === DIAL_CODE.INDIA &&
        !PHONE_NUMBER_INDIA_REGEX.test(value)
      ) {
        setErrorData({ ...errorData, phoneError: "Enter valid phone number" });
      } else if (
        dialcode === DIAL_CODE.SINGAPORE &&
        !PHONE_NUMBER_SINGAPORE_REGEX.test(value)
      ) {
        setErrorData({ ...errorData, phoneError: "Enter valid phone number" });
      } else {
        if (value.length < 10 || value.length > 15)
          setErrorData({
            ...errorData,
            phoneError: "Enter valid phone number ",
          });
      }
    }
  };

  const onChange = (e: any) => {
    validateFields(e.target.name, e.target.value);
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const updateProfile = async () => {
    try {
      const res = await editProfileService({
        displayName: formData.displayName,
        firstName: formData.displayName,
        email: formData.email,
        mobile: formData.mobile,
        address: formData.address,
        dialCode: formData.dialCode,
        profileImageUrl: formData.profileImageUrl,
      });

      if (res.data) {
        toastMessage(successMessage().PROFILE_UPDATE_SUCCESS, "success");
        localStorage.setItem("user", JSON.stringify(res.data));
      }
      onClose();
    } catch (error: any) {
      toastMessage(error.data.response.message, "error");
      console.log(error);
    }
  };
  const onChangePhone = (e: string) => {
    if (e) {
      let phone: any = e.split(" ");
      let dialCode = phone[0];
      let mobile = "";
      phone.forEach((each: any, index: number) => {
        if (index > 0) {
          mobile = mobile + each + " ";
        }
      });
      setFormData({
        ...formData,
        phone: e,
        mobile: mobile,
        dialCode: dialCode,
      });
    }
    validateFields("phone", e);
  };
  const handleSaveButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    updateProfile();
  };
  const handleChange = (event: any) => {
    if (
      event.target.files.length > 0 &&
      fileTypeMatch("image/*", event.target.files[0].type, "Invalid file type")
    ) {
      const tempformData = new FormData();
      tempformData.append("file", event.target.files[0]);
      bulkUploadService(tempformData).then((res: any) => {
        setIsFileUploaded(true);
        setFormData((prevState: any) => {
          return {
            ...prevState,
            profileImageUrl: res.data.Location,
          };
        });
      });
    }
  };
  const handleClick = () => {
    setIsFileUploaded(false);
    if (inputRef.current !== null) {
      inputRef.current.click();
    }
  };
  return (
    <>
      <div className="pw-editprofile-header">
        <text className="edit">{t("Edit account")}</text>
        <Button onClick={onClose}>
          <CloseIcon className="icon"></CloseIcon>
        </Button>
      </div>
      <div className="overflow-y-auto ">
        <div className="sidepadding">
          {/* <ProfileImage /> */}
          <div>
            <input
              type="file"
              accept="image/*"
              hidden
              ref={inputRef}
              onChange={(e) => handleChange(e)}
            />

            <div>
              <img
                src={
                  formData.profileImageUrl
                    ? formData.profileImageUrl
                    : "assets/images/AvatarEmpty.png"
                }
                alt=" "
                onClick={handleClick}
                className="profile"
              />
            </div>
          </div>
          <div className="">
            <div className="pw-input-label">
              <text className="name">{t("Name")}</text>
            </div>
            <TextField
              type="text"
              variant="outlined"
              placeholder={t("Name")}
              size="small"
              name="displayName"
              className="pw-width-100 pw-input-field"
              value={displayName}
              onChange={(e) => onChange(e)}
            />
            {nameError ? (
              <span className="pw-display-error">*{nameError}</span>
            ) : (
              ""
            )}
          </div>
          <div className="">
            <div className="pw-input-label">
              <text className="name">{t("email")}</text>
            </div>
            <TextField
              type="text"
              variant="outlined"
              placeholder={t("email")}
              size="small"
              name="email"
              className="pw-width-100 pw-input-field"
              value={email}
              disabled={true}
            />
            {emailError ? (
              <span className="pw-display-error">* {emailError}</span>
            ) : (
              ""
            )}
          </div>
          <div className="">
            <div className="pw-input-label">
              <text className="name"> {t("Contact")}</text>
            </div>
            {/* <App/> */}
            <div className="pw-phone-input">
              <PhoneInput
                className="pw-inpt-label"
                initialCountry="in"
                value={phone}
                onChange={(e) => onChangePhone(e)}
              />
              {phoneError && (
                <span className="pw-display-error">{phoneError}</span>
              )}
            </div>
          </div>
          <hr className="line" />
          {/* <text className="text"> {t("Address")}</text> */}
          {/* <Button
            variant="outlined"
            className="addressButton"
            onClick={handleAddressClick}
          >
            <div className="addIcon">
              <AddIcon />
            </div>
            <text className="add">{t("Add Address")}</text>
          </Button> */}
          {/* {allAddresses.map((address) => {
            return (
              <>
                <textarea className="textarea" rows={5} />
                <div className="home">
                  <Button
                    onClick={(e) => {
                      handleHomeAddressSelection(e, address);
                    }}
                    style={{
                      width: "47px",
                      height: "28px",
                      backgroundColor: address.isHomeSelected
                        ? "#DCFFED"
                        : "#EAEEF4",
                      color: address.isHomeSelected ? "#47A573" : "#3D4A5C",
                      border: address.isHomeSelected
                        ? "2px solid #B8FCD9"
                        : "2px solid #EAEEF4",
                      borderRadius: "8px",
                    }}
                  >
                    {t("Home")}
                  </Button>
                  <Button
                    onClick={(e) => {
                      handleWorkAddressSelection(e, address);
                    }}
                    style={{
                      width: "47px",
                      height: "28px",
                      // backgroundColor: '#DCFFED', // color of selected button
                      backgroundColor: address.isWorkSelected
                        ? "#DCFFED"
                        : "#EAEEF4",
                      color: address.isWorkSelected ? "#47A573" : "#3D4A5C",
                      border: address.isWorkSelected
                        ? "2px solid #B8FCD9"
                        : "2px solid #EAEEF4",
                      borderRadius: "8px",
                    }}
                  >
                    {t("Work")}
                  </Button>
                  <div
                    className=" pw-removeicon text-neutral-400"
                    onClick={(e) => {
                      handleRemove(address);
                    }}
                  >
                    {" "}
                    <CancelIcon />{" "}
                  </div>
                </div>
              </>
            );
          })} */}
          <div className="">
            <div className="flex flex-row pw-form-field">
              <div className="pw-input-label pw-text">{t("address")}</div>
              {/* <div className="pw-mandatory-icon">*</div> */}
            </div>

            <MapsInput
              isTextArea
              defaultValue={formData?.address}
              placeholder="Address"
              value={formData?.address?.addressLine1 || ""}
              onChange={onChangeAddress}
              formData={formData}
              setFormData={setFormData}
              className="pw-width-100 pw-input-field pw-input-text"
              sx={styles}
            />
          </div>
        </div>
        {/* <Footer/>                    */}
      </div>
      <div className="pw-footerMain">
        <Button
          variant="outlined"
          onClick={onClose}
          style={{
            border: "1px solid #3D4A5C",
            color: "#1D2025",
          }}
        >
          <text className="pw-cancelText"> {t("Cancel")}</text>
        </Button>
        <Button
          variant="contained"
          disabled={!isValidForm()}
          onClick={(e) => {
            isValidForm() && handleSaveButton(e);
          }}
          style={{
            color: "#FAFBFD",
          }}
        >
          {t("Save")}
        </Button>
      </div>
    </>
  );
};
export default EditProfile;
